import {
  FETCH_BACKUPS_REQUEST,
  FETCH_BACKUPS_SUCCESS,
  FETCH_BACKUPS_FAILURE,
  FETCH_BACKUP_TABLES_SUCCESS,
  FETCH_QUEUE_HEALTH_SUCCESS,
} from "../../actions/databaseBackups"

const initialState = {
  loading: false,
  list: { data: [], current_page: 1, last_page: 1, total: 0 },
  tables: [],
  queueHealth: { healthy: true, oldest_queued_age_seconds: 0, queue_connection: null },
}

const databaseBackups = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_BACKUPS_REQUEST:
      return { ...state, loading: true }
    case FETCH_BACKUPS_SUCCESS:
      return { ...state, loading: false, list: action.payload }
    case FETCH_BACKUPS_FAILURE:
      return { ...state, loading: false }
    case FETCH_BACKUP_TABLES_SUCCESS:
      return { ...state, tables: action.payload }
    case FETCH_QUEUE_HEALTH_SUCCESS:
      return { ...state, queueHealth: action.payload }
    default:
      return state
  }
}

export default databaseBackups
